export default "__VITE_ASSET__8ed5132a__"